
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"devId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientIp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sessionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"devTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"osVer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deactivationReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"integrationName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vcId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dogLink"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"appClientIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"existingPings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"auditS3FileNames"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parsedUserAgent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"truncated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"truncatedAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":545}};
    doc.loc.source = {"body":"query TestSession($catId: String!) {\n  testSession(catId: $catId) {\n    id\n    appId\n    devId\n    clientIp\n    createdAt\n    updatedAt\n    active\n    sessionType\n    bid\n    devTypeId\n    osVer\n    deactivatedAt\n    deactivationReason\n    archived\n    catId\n    integrationName\n    vcId\n    clientId\n    initiator\n    title\n    countryCode\n    user {\n      id\n      name\n      email\n    }\n    apps {\n      appId\n      dogLink\n    }\n    appClientIds\n    existingPings\n    auditS3FileNames\n    parsedUserAgent\n    truncated\n    truncatedAt\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TestSession"] = oneQuery(doc, "TestSession");
        
